import { render } from "./item-payment.vue?vue&type=template&id=04ce9794&scoped=true"
import script from "./item-payment.vue?vue&type=script&lang=js"
export * from "./item-payment.vue?vue&type=script&lang=js"

import "./item-payment.vue?vue&type=style&index=0&id=04ce9794&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04ce9794"]])

export default __exports__